// Document Title / Description Hook
//
// Sets a release-specific document title and meta description while a
// Release_Page is mounted, then restores the generic defaults on unmount.
// The static defaults in public/index.html stay generic ("Protheus Releases")
// so the tab is meaningful before React hydrates and for any non-release route.

import { useEffect } from 'react';

const DEFAULT_TITLE = 'Protheus Releases';
const DEFAULT_DESCRIPTION = 'Protheus Releases - Portal de documentação e recursos';

export function useDocumentTitle(releaseId) {
  useEffect(() => {
    const title = releaseId
      ? `Protheus Release 12.1.${releaseId}`
      : DEFAULT_TITLE;
    const description = releaseId
      ? `Protheus Release 12.1.${releaseId} - Portal de documentação e recursos`
      : DEFAULT_DESCRIPTION;

    document.title = title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDescription) {
        metaDescription.setAttribute('content', DEFAULT_DESCRIPTION);
      }
    };
  }, [releaseId]);
}
